<div class="content content-md">
  <div
    infinite-scroll
    [infiniteScrollDistance]="scrollDistance"
    [infiniteScrollThrottle]="300"
    [scrollWindow]="false"
    (scrolled)="onScrollDown()"
    [ngClass]="scrollContentClass"
    >
    @if (isBusy || searchService.isSearching) {
      <app-overlay imgClass='cg-overlay-img'></app-overlay>
    }
    @if (!searchService.isSearching && !searchResults && productTypes) {
      <div>
        @for (productType of productTypes; track productType; let i = $index) {
          <app-product-type-item
            [id]="'list-item' + i"
            [productType]="productType"
            [getLabelTranslation]="getLabelTranslation"
            [showHourly]="showHourly()"
            [showEstimate]="showEstimates()"
            [selectedCustomerCount]="selectedCustomerCount"
            [labels]="labels"
            [localeFormat]="defaultsService.localeFormat"
            [openAssetAvailability]="openAssetAvailability"
            [estimateColors]="estimateColors()"
            class="content-list-item"
            />
        }
      </div>
    }
  </div>
  @if (searchResults) {
    <app-search-results />
  }
</div>
